export default "__VITE_ASSET__DE3ROP3t__"